import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const InboundDeliveryItemsByIdQuery = graphql(/* GraphQL */ `
  query inboundDeliveryItemsById($inboundDeliveryByIdInput: ByIdInput!) {
    inboundDeliveryById(input: $inboundDeliveryByIdInput) {
      ...InboundDeliveryItems
    }
  }
`);
